import { SET_ERROR_MESSAGE, SET_ERROR_MESSAGE_MODAL } from "../constants";

export const setErrorMessage = (payload) => ({
  type: SET_ERROR_MESSAGE,
  payload,
});

export const setErrorModalClose = (payload) => ({
  type: SET_ERROR_MESSAGE_MODAL,
  payload,
});
